import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isGrid, isModal } = {}) => ({
  svg: {
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('lg')]: {
      width: 199,
    },
    [theme.breakpoints.down('md')]: {
      width: isGrid || isModal ? '29vw' : 90,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        width: 199,
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        width: isGrid || isModal ? '29vw' : 90,
      }),
    },
  },
}));
